<template>
  <div class="diaglog-wrapper">
    <transition name="fade-in">
      <div class="dialog-mask"></div>
    </transition>
    <transition name="scale-in" @after-leave="closePopup">
      <article v-if="showContent" class="dialog-container tips-dialog">
        <div class="tips-dialog-wrapper">
          <h1 class="dialog-title">
            {{ languages.quickcard_info_title }}
          </h1>
          <div class="tips-content">
            <p class="left-text">{{ languages.quickcard_info_tip_one }}</p>
            <p class="left-text">{{ languages.quickcard_info_tip_two }}</p>
          </div>
        </div>
        <button class="sure-btn" @click="hideContent">
          {{ languages.confirm }}
        </button>
      </article>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'quickPayCardPopup',
  props: {
    languages: {
      require: true
    }
  },
  data() {
    return {
      showContent: false
    };
  },
  mounted() {
    this.showContent = true;
  },
  beforeDestroy() {
    this.showContent = false;
  },
  methods: {
    closePopup() {
      this.$emit('close');
    },
    hideContent() {
      this.showContent = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';
.dialog-mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.dialog-container.tips-dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  box-sizing: border-box;
  width: 708px;
  transform: translate(-50%, -50%);
  background: $backgroundColor;
  padding: 0;
}
.dialog-title {
  @include g-popup-title();
}
.tips-content {
  padding: 0 40px 20px;
  color: #333333;
  text-align: left;
}

.sure-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  font-size: 24px;
  height: 80px;
  color: #fff;
  border-radius: 9px;
  margin: 0 auto 40px;
  padding: 0 74px;
  background: $themeColor;
  cursor: pointer;
}
.tips-dialog-wrapper {
  height: auto;
  min-height: unset;
}
@media screen and (orientation: landscape) {
  .tips-content {
    line-height: 30px;
  }
  .sure-btn {
    font-size: 18px;
    height: 60px;
  }
}
</style>
